import { useContext, useState } from 'react';
import NavLinkExt from './NavLinkExt';

const SubNavbar = ({navSections, localPath}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const pathList = localPath.split('/');
  const activeSection = navSections.find(({path}) => path === pathList[0]);
  const activeSubsection = activeSection && activeSection.sections.find(({path}) => path === (pathList.length > 1 && pathList[1]));

  const [selectedSection, setSelectedSection] = useState(activeSection);

  const openMenu = () => {
    setMenuOpen(isOpen => !isOpen);
    setSelectedSection(activeSection);
  };

  // mobile
  if (window.innerWidth < 640) {
    return (
      <>
        <div className="relative">
          {activeSection
          ?
          <div className="relative md:tracking-wide flex flex-row" onClick={openMenu}>
            <div className="bg-cod-gray p-3 ">{activeSection && activeSection.label}</div>
            <div className="bg-cod-gray-mid w-full p-3 flex flex-row justify-between">
              <div>{activeSubsection && activeSubsection.label}</div>
              <div>
                <svg viewBox="0 0 24 24" width="24" height="24" fill="white">
                            {menuOpen ?
                            <>
                                <line x1="4" y1="4" x2="21" y2="20" stroke="white" strokeWidth="3" />
                                <line x1="4" y1="20" x2="21" y2="4" stroke="white" strokeWidth="3" />
                            </>
                            :
                            <>
                                <rect y="5"  x="2" width="21" height="2" rx="0"></rect>
                                <rect y="11" x="2" width="21" height="2" rx="0"></rect>
                                <rect y="17" x="2" width="21" height="2" rx="0"></rect>
                            </>}
                        </svg>
              </div>
            </div>
          </div>
          :
          <div className="flex flex-col mt-6 mx-8 space-y-6 md:tracking-wide">
          <div className="p-3 rounded bg-cod-gray-mid relative">
            {navSections.map(({label, path}) =>
              <NavLinkExt
                label={label}
                path={path}
                key={path}
                className="flex bg-cod-gray p-3 my-1 w-full"
              />
            )}
          </div>
        </div>}
        {menuOpen &&
          <>
            <div className="h-screen w-screen top-0 fixed z-20" onClick={openMenu}></div>
            <div className="absolute z-30 mt-1 w-full md:tracking-wide flex flex-row">
              <div className="bg-cod-gray flex flex-col space-y-2 p-3 w-auto rounded-l-xl ">
                {navSections.map(section =>
                  <div
                    key={section.label}
                    className={`p-2 border-l-2 ${section.path === selectedSection.path
                                      ? 'border-utrgv-blue '
                                      : 'border-transparent'
                                    }`}
                    onClick={() => { setSelectedSection(section); }}
                  >{section.label}</div>
                )}
              </div>
              <div className="bg-cod-gray-mid flex flex-col space-y-2 px-2 py-4 w-full rounded-r-xl">
                {selectedSection.sections.map(({label, path}) =>
                  <NavLinkExt
                    label={label}
                    path={`${selectedSection.path}/${path}`}
                    className='px-2 border-l-2 '
                    activeClass='border-utrgv-blue'
                    inactiveClass='border-transparent'
                    onClick={openMenu}
                  />
                )}
              </div>
            </div>  
          </>}
        </div>
      </>
    )}

  return (
    <>
      <div className="relative">
        {activeSection
        ?
        <div className="relative bg-cod-gray-mid md:tracking-wide">
          <ul className="flex md:space-x-4 items-center">
            <li className={`mr-1 inline-block py-4 pl-2 pr-4 bg-cod-gray text-white
                ${navSections.length === 1 ? 'pl-5' : 'cursor-pointer'}`}
                onClick={navSections.length > 1 ? openMenu : undefined}
                >
                  {navSections.length > 1 &&
                  <svg className="inline" viewBox="0 0 24 24" width="24" height="24" fill="white">
                      {menuOpen
                      ?
                      <>
                      <line x1="6"  y1="14" x2="12" y2="8"  stroke="white" strokeWidth="1" />
                      <line x1="12" y1="8"  x2="18" y2="14" stroke="white" strokeWidth="1" />
                      </>
                      :
                      <>
                      <line x1="6"  y1="8"  x2="12" y2="14" stroke="white" strokeWidth="1" />
                      <line x1="12" y1="14" x2="18" y2="8"  stroke="white" strokeWidth="1" />
                      </>
                      }
                  </svg>}
                  {activeSection.label}
            </li>
            {activeSection.sections.map(({label, path}, i) =>
              <li className="mr-1" key={i}>
                <NavLinkExt
                  label={label}
                  path={`${activeSection.path}/${path}`}
                  className='inline-block py-2 px-4 text-white border rounded border-transparent'
                  activeClass='bg-utrgv-blue'
                  inactiveClass='hover:border-utrgv-blue active:bg-utrgv-lightgray'
                />
              </li>)}
          </ul>
        </div>    
        :
        <div className="relative bg-cod-gray md:tracking-wide p-2">
          <ul className="flex md:space-x-4 items-center">
            {navSections.map(({label, path}, i) =>
            <li className="mr-1" key={i}>
              <NavLinkExt
                label={label}
                path={path}
                key={path}
                className='inline-block py-2 px-4 text-white border rounded border-transparent'
                activeClass='bg-utrgv-blue'
                inactiveClass='hover:border-utrgv-blue active:bg-utrgv-lightgray'
              />
            </li>)}
          </ul>
        </div>}
        {menuOpen &&
        <>
          <div className="h-screen w-screen top-0 fixed z-20" onClick={openMenu}></div>
          <div className="absolute z-30 mt-1 ml-1 w-full md:tracking-wide flex flex-row">
            <div className="bg-cod-gray flex flex-col space-y-2 p-3 pr-4 w-auto rounded-xl ">
              {navSections.map(section =>
                <NavLinkExt
                  label={section.label}
                  path={section.path}
                  key={section.path}
                  className='p-2 border-l-2'
                  activeClass='border-utrgv-blue'
                  inactiveClass='border-transparent'
                  onClick={openMenu}
                />
              )}
            </div>
          </div>
        </>}
      </div>
    </>
  );
};

export default SubNavbar;
